/**
 * ATENA CONSULTING — blocco-carousel-loghi.js
 *
 * SwiperJS carousel loghi con:
 * - 4 slide visibili su desktop
 * - Navigazione rettangoli custom (no frecce)
 * - Autoplay con pause al hover
 * - Responsive: 4 → 3 → 2 → 1
 */

// import Swiper from 'swiper';
// import Swiper, { Navigation, Pagination, Scrollbar, Autoplay } from "swiper";

//import Swiper from "swiper";
import Swiper, { Navigation, Pagination, Scrollbar, Autoplay } from "swiper";
import "swiper/css";
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';

const bloccoCarouselLoghi = () => {

  document.querySelectorAll('.blocco_carousel_loghi__swiper').forEach(container => {

    new Swiper(container, {
      modules: [Pagination, Autoplay],

      // ── Slide visibili ────────────────────
      slidesPerView: 1,
      spaceBetween:  16,

      breakpoints: {
        576: { slidesPerView: 2, spaceBetween: 16 },
        768: { slidesPerView: 3, spaceBetween: 20 },
        992: { slidesPerView: 4, spaceBetween: 24 },
      },

      // ── Rewind ───────────────────────────
      // NB: niente `loop`. Con 5 loghi e 4 slide visibili non ci sono
      // abbastanza slide per il loop di Swiper 9 (ne servirebbero
      // slidesPerView * 2 = 8): il loop si blocca e ferma l'autoplay.
      // In più `loop` forza un bullet per slide (5) invece di uno per
      // pagina (2). Con `rewind` l'autoplay non si ferma mai e torna
      // all'inizio alla fine.
      loop:   false,
      rewind: true,

      // ── Autoplay ─────────────────────────
      autoplay: {
        delay:                1000,
        disableOnInteraction: false,
        pauseOnMouseEnter:    false,
      },

      // ── Paginazione rettangoli ────────────
      pagination: {
        // Scoped al container: con più blocchi in pagina un selettore
        // globale li aggancerebbe tutti alla prima paginazione.
        el:        container.querySelector('.blocco_carousel_loghi__pagination'),
        clickable: true,
      },

    });

  });

};

export default bloccoCarouselLoghi;
